<template>
  <multiselect
    v-model="value"
    :options="options"
    :searchable="false"
    :close-on-select="closeOnSelect"
    :show-labels="false"
    :placeholder="placeholder"
    :multiple="multiple"
    :limit="limit"
    :limit-text="limitText"
  >
    <!-- <template slot="selection" slot-scope="{ values, isOpen }">
      <span
        class="multiselect__single"
        v-if="values.length &amp;&amp; !isOpen"
      >{{ values.length }} options selected</span>
    </template>-->
  </multiselect>
</template>
<script>
import Multiselect from 'vue-multiselect'
import '../../../styles/components/custom-select.css'

export default {
  name: 'customSelect',

  components: {
    Multiselect,
  },
  data() {
    return {
      value: null,
    }
  },
  props: {
    label: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    searchable: {
      type: Boolean,
      default: false,
    },
    closeOnSelect: {
      type: Boolean,
      default: true,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    limit: {
      type: Number,
      default: 1,
    },
    options: {
      type: Array,
      default: () => [],
    },
  },

  methods: {
    limitText(count) {
      return `${count + 1} selected`
    },
  },
}
</script>